import { TypedUseSelectorHook, useSelector as useSelectorBase } from 'react-redux'

import type { RootReducerState } from '@redux/modules/types'

const useSelector: TypedUseSelectorHook<RootReducerState> = useSelectorBase

export default useSelector
